import React, { useState } from 'react';
import { Button, IconButton, Tooltip, TableCell } from '@material-ui/core';
import FileCopy from '@material-ui/icons/FileCopy';
import CloneMeasurementDialog from './CloneMeasurementDialog';

function CloneMeasurementButton(props) {
    const [openDialog, setOpenDialog] = useState(false);

    return (
        <>

            {props.form ? <Button className='whitespace-nowrap mx-4' variant='contained' color='secondary' disabled={!props.item || !props.item.id} onClick={e => { setOpenDialog(true); e.preventDefault(); }} startIcon={<FileCopy className='hidden sm:flex' />}>
                Clone
            </Button> : <TableCell className='w-auto text-center' padding='none'>
                <Tooltip title='Clone'>
                    <IconButton onClick={e => { setOpenDialog(true); e.preventDefault(); }}><FileCopy fontSize='small' /></IconButton>
                </Tooltip>
            </TableCell>}

            {openDialog && (<CloneMeasurementDialog subject={props.item.id} onCancel={() => setOpenDialog(false)} onSave={result => { setOpenDialog(false); }} />)}

        </>
    );
}

export default CloneMeasurementButton;
